import React from 'react'
import HeaderTwo from '../../Components/Header2/HeaderTwo'

export default function Blog() {
    return (
        <div>
            <HeaderTwo />

            <div className=' flex justify-center items-center h-[400px]'>
                <h1 className=' text-white font-bold uppercase text-2xl '>Coming Soon...</h1>
            </div>
        </div>
    )
}
